/** Crew segment of a boat config: 4 and C4 both become C4. Other tokens are unchanged. */
export function crewConfigToken(crew: string | number | null | undefined): string {
  const text = String(crew ?? '').trim();
  if (!text || text === '0' || /^na$/i.test(text) || text.toLowerCase() === 'nan') {
    return '';
  }
  if (/^c\d+$/i.test(text)) {
    return `C${text.slice(1)}`;
  }
  if (/^\d+$/.test(text)) {
    return `C${text}`;
  }
  return text;
}

/**
 * Name-headsail-crew configs use a C# crew segment: M21-LA2-C4, never M21-LA2-4.
 * A last segment that is not a crew count (HW1, R2) is left as written.
 */
export function normalizeConfigCode(config: string | null | undefined): string {
  const text = String(config ?? '').trim();
  if (!text || text.toUpperCase() === 'NA') {
    return text;
  }
  const parts = text.split('-').map((part) => part.trim()).filter((part) => part !== '');
  if (parts.length === 0) {
    return text;
  }
  const token = crewConfigToken(parts[parts.length - 1]);
  if (token) {
    parts[parts.length - 1] = token;
  }
  return parts.join('-');
}

/** Join config parts and apply the crew-token rule to the last non-empty part. */
export function joinConfigCode(parts: Array<string | number | null | undefined>): string {
  const raw = parts.map((part) => String(part ?? '').trim()).filter((part) => part !== '').join('-');
  return normalizeConfigCode(raw);
}
